import { render, staticRenderFns } from "./MultiTagInput.vue?vue&type=template&id=05f80e20&scoped=true&"
import script from "./MultiTagInput.vue?vue&type=script&lang=js&"
export * from "./MultiTagInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiTagInput.vue?vue&type=style&index=0&id=05f80e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f80e20",
  null
  
)

export default component.exports